/* unplugin-vue-components disabled */import script from "./tabbar.vue?vue&type=script&setup=true&lang=js"
export * from "./tabbar.vue?vue&type=script&setup=true&lang=js"

import "./tabbar.vue?vue&type=style&index=0&id=37d373b1&scoped=true&lang=scss"

import exportComponent from "/Users/admin/Desktop/project/48tk_gai/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-37d373b1"]])

export default __exports__